export default __webpack_public_path__ + "static/media/step_img_8.e58ffb75.png";